import React from 'react'

import { MobXProviderContext, observer } from 'mobx-react'

import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import ProjectSetupResourceProperties from '~/client/src/desktop/views/ProjectSetUp/components/ProjectSetupResourceConfig/ResourceProperties/ProjectSetupResourceProperties'
import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useLocationResourceStore } from '~/client/src/shared/hooks/useLocationResourceStore'

function LocationsProperties(): React.ReactElement {
  const { state } = React.useContext(MobXProviderContext) as {
    state: DesktopInitialState
  }
  const { schema } = useLocationResourceStore(state.activeProject?.id)

  return (
    <ProjectSetupResourceProperties
      resourceTypeId={ResourceTypeId.LOCATIONS}
      columnConfigKey={LocalStorageKey.LocationsPropertiesColumnConfig}
      resourceSchema={schema}
    />
  )
}

export default observer(LocationsProperties)
